<template>
  <div>
    <basic-container>
      <!--下拉列表-->
      <!--<template >-->
      <!--<el-select v-model="value" placeholder="请选择"  @change="statusChange">-->
      <!--<el-option-->
      <!--v-for="item in statusData"-->
      <!--:key="item.value"-->
      <!--:label="item.label"-->
      <!--:value="item.value">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</template>-->

      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @search-reset="searchClear"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot="searchMenu">
          <!-- <el-button
            size="small"
            class="el-icon-delete"
            @click="searchClear"
            style="width: 80px;left: -88px;position: relative;"
          >清空</el-button>-->
        </template>
        <template slot="search"></template>
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-printer"
            size="small"
            plain
            @click.stop="printJson()"
          >打印</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="downloadExcelPayment"
          >下载Excel</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <!-- <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="toPaymentDetail(scope.row)"
          >查看应付款明细</el-button> -->
          <el-button
            type="success"
            v-if="scope.row.status == 'NO'"
            size="small"
            plain
            @click="openPay(scope.row) "
          >付款</el-button>
        </template>
      </avue-crud>
      <template>
        <el-dialog
          title="二维码支付"
          :visible.sync="QRCodeDialog"
          align="center"
        >
          <vue-qr
            :text="config.value"
            :size="200"
          ></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="QRCodeDialog = false">关闭</el-button>
        </el-dialog>
        <el-dialog
          title="选择付款方式"
          center
          :visible.sync="dialogBalancePay"
          width="50%"
        >
          <div style="display: flex;justify-content: space-around;">
            <el-radio
              v-if="!noMoney"
              v-model="balancePayRadio"
              label="YE"
            >账户余额({{getBalance+'元'}})</el-radio>
            <el-radio
              v-if="noMoney"
              v-model="balancePayRadio"
              label="YE"
            >
              账户余额(
              <span style="color:red">
                余额不足
                <a
                  href="#"
                  style="color:#409EFF;margin-left:3px;text-decoration: underline;"
                  @click="toPayMoney"
                >去充值</a>
              </span>)
            </el-radio>
            <el-radio
              v-model="balancePayRadio"
              label="WX"
            >微信支付</el-radio>
          </div>
          <span
            slot="footer"
            class="dialog-footer"
          >
            <el-button @click="dialogBalancePay = false">取 消</el-button>
            <el-button
              type="primary"
              @click="listPay"
            >确认支付</el-button>
          </span>
        </el-dialog>
      </template>
    </basic-container>
  </div>
</template>

    <script>
import { mapGetters } from "vuex";
import { paymentOption } from "@/const/salesCloud/paymentOption";
import {
  statusSearch,
  updateWorkOrderMerchants,
  evaluation,
  findItemsByCategory,
  insertWorkOrderMerchants,
  userPass,
  userRefused,
  cancelWorkOrder,
} from "@/api/salesCloud/workOrder";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { findArList } from "@/api/salesCloud/ar";
import {
  invoiceSystemV2ReceiverAgentPay,
  invoiceSystemV2ReceiverAgentPayDownload,
  agentPay,
} from "@/api/salesCloud/payment";
import { findUserInfo } from "@/api/basic/user";
import { DIC } from "@/const/dic";
import { excelaxios } from "@/util/excelaxios";
import VueQr from "vue-qr";
import { getCompany } from "@/util/auth";
import { exportExcel } from "xlsx-oc";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { log } from "util";
import { findBalance, addBalance } from "@/api/salesCloud/accountBalance";

export default {
  name: "payment",
  components: {
    VueQr,
  },
  data() {
    return {
      tableOption: paymentOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      eleDialog: false,
      serviceCategoryId: "",
      serviceItemId: "",
      stockData: "",
      payTime: {},
      from: {
        text: "text",
      },
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      users: [],
      userType: "JOINS_ENGINEER",
      point: {},
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      QRCodeDialog: false,
      config: {},
      noMoney: true,
      getBalance: 0,
      balancePayRadio: "YE",
      evaluateDialog: false,
      dialogBalancePay: false,
      score: 5,
      clues: [],
      evaluateObj: {},
      serviceItem: {},
      workerUser: {},
      workOrderData: {},
      stockSuperviseDialog: false,
      serviceFee: [],
      propertiesViceList: [],
      value: "",
      downloadData: {},
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    openPay(row) {
      console.log(row);
      this.payRow = row;
      findBalance().then((res) => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.getBalance = data.rows[0].balance;
        let wxPay = row.money;
        // let wxPay = 1111111;
        console.log(wxPay, this.getBalance);
        this.noMoney = wxPay > this.getBalance;
        this.dialogBalancePay = true;
      });
    },
    listPay() {
      if (this.balancePayRadio == "WX") {
        this.agentPayment(this.payRow.id);
      } else {
        let params = {
          payType: "BALANCE",
        };
        agentPay(this.payRow.id, params).then((res) => {
          console.log(res);
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "支付成功",
              type: "success",
            });
            this.handleList();
            setTimeout(() => {
              this.handleList();
            }, 1000);
            this.dialogBalancePay = false;
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            this.handleList();
            this.dialogBalancePay = false;
          }
          this.handleList();
        });
      }
    },
    toPayMoney() {
      console.log("充值");
      this.$router.push({ path: "/salesCloud/accountBalance" });
    },
    stockRemovalSubmit() {
      console.log(this);
    },
    handleDialog(row, index) {
      this.stockSuperviseDialog = true;
      // this.evaluateDialog =true
      this.formobj = row;
      console.log(row, index);
    },
    statusChange() {
      //下拉框状态发生改变时
      //console.log(this.value);
      let params = this.value;
      statusSearch(params).then((res) => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      invoiceSystemV2ReceiverAgentPay(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      invoiceSystemV2ReceiverAgentPay(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchClear() {
      // this.$refs.crud.$refs.searchForm.resetFields();
      this.serviceCategory = "";
      this.serviceCategoryId = "";
      this.serviceItem = "";
      this.serviceItemId = "";
      console.log(this);
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }

      this.downloadData = params;
      console.log(params);
      console.log(this);
      invoiceSystemV2ReceiverAgentPay(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      console.log(params);
      invoiceSystemV2ReceiverAgentPay(params).then((res) => {
        let data = JSON.parse(res.data);
        console.log(res, "invoiceSystemV2ReceiverAgentPay");
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },

    handleDetail(row, index) {},
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.point = {};
      this.serviceCategory = {};
      this.joinsWorkServiceItems = [];
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.workerUser = {};
      this.serviceCategory.id = row.serviceCategoryId;
      this.choseWorkServiceItem();
      this.workerUser.id = row.workerUserId;
      let location = {};
      console.log("集合：" + JSON.stringify(row));
      location.lng = row.longitude;
      location.lat = row.latitude;
      this.point.location = location;
      this.point.pname = row.province;
      this.point.cityname = row.city;
      this.point.adname = row.area;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = params;
      invoiceSystemV2ReceiverAgentPay(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.workerUserId = this.workerUser.id;
      row.serviceItemId = this.serviceItem;
      console.log("serviceItem：" + JSON.stringify(this.serviceItem));
      insertWorkOrderMerchants(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.workerUserId = this.workerUser.id;
      console.log("集合：" + JSON.stringify(row));
      updateWorkOrderMerchants(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    choseWorkServiceItem() {
      console.log(this.serviceCategory.id);
      findItemsByCategory(this.serviceCategory.id).then((res) => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
        console.log(res);
        console.log(data);
      });
      this.serviceItem = "";
    },
    choseServiceItem(data) {
      console.log(data);
      this.serviceItemId = data;
      console.log(this.serviceItemId);
    },
    userPass(row) {
      console.log(row);
      let obj = {};
      obj.id = row.id;
      userPass(obj).then((res) => {
        this.handleList();
      });
    },
    userRefused(row) {
      this.$prompt("请输入拒绝理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255",
      }).then(({ value }) => {
        let obj = {};
        obj.id = row.id;
        obj.reason = value;
        userRefused(obj).then((res) => {
          this.handleList();
        });
      });
    },
    agentPayment(row) {
      console.log(row);
      this.config.value = "";
      let params = {
        payType: "WX_PAY",
      };
      let id = row;
      agentPay(id, params).then((response) => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          let count = 0;
          wxNativePayQuery(data.outTradeNo).then((res) => {
            console.log(res);
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(function () {
                  _this.QRCodeDialog = false;
                  _this.$message({
                    showClose: true,
                    message: "支付成功",
                    type: "success",
                  });
                  _this.handleList();
                  _this.dialogBalancePay = false;
                }, 1000);
              } else {
                count++;
                if (count < 5) {
                  wxNativePayQuery(data.outTradeNo);
                } else {
                  this.QRCodeDialog = false;
                  this.$message({
                    showClose: true,
                    message: "支付超时",
                    type: "error",
                  });
                  console.log("超时", new Date());
                }
              }
              //this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error",
              });
              this.handleList();
            }
          });
          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;
          this.config.value = "";
          this.config.value = data.codeUrl;
          console.log("集合：" + this.config.value);
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
          //???下面的感觉没用
          done();
          this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    showEvaluate(row) {
      this.evaluateObj.workOrderId = row.id;
      this.evaluateDialog = true;
    },
    rateChange() {
      //alert(this.evaluateObj.score);
    },
    evaluate() {
      // this.evaluateObj.workOrderId=row.id;
      console.log("集合：" + JSON.stringify(this.evaluateObj));
      // evaluation(this.serviceCategory.id).then((res) => {
      //     let data = JSON.parse(res.data)
      //     this.joinsWorkServiceItems = data
      // })

      evaluation(this.evaluateObj)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "评价成功",
              type: "success",
            });
            this.handleList();
            this.evaluateDialog = false;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
    },
    toPaymentDetail(row) {
      let params = {
        id: row.id,
      };
      this.$router.push({ name: "应付款详情", params });
      console.log(row.id);
      console.log(row);
    },
    formmaterImage(row) {
      let str = new Array();
      console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    cancelWorkOrder(id) {
      this.$confirm(`是否确认取消?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cancelWorkOrder(id)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "取消成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    downloadExcelPayment() {
      // let params = this.downloadData;
      // let url = `/joins-invoice-system/v1/ar/exportPayment?`;
      // excelaxios(url, params);
      let params = this.downloadData;
      invoiceSystemV2ReceiverAgentPayDownload(params).then((res) => {
        window.open(res);
      });
    },
    printJson() {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      invoiceSystemV2ReceiverAgentPay(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        let someJSONdata = data.rows;
        someJSONdata = someJSONdata.map((item) => {
          this.tableLoading = true;
          item.payTime = item.payTime ? formatterDateToUTC(item.payTime) : "";
          if (item.clearingType == "CASH") {
            item.clearingType = "现款现货";
          } else if (item.clearingType == "INSTALLMENT") {
            item.clearingType = "月结";
          } else {
            item.clearingType = "error:" + item.clearingType;
          }
          return item;
        });
        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        printJS({
          printable: someJSONdata,
          header: `<div style='position:absolute;bottom:0;display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "number", displayName: "应付款编号" },
            { field: "purchaseNumber", displayName: "采购订单编号" },
            { field: "account", displayName: "账号" },
            { field: "shopName", displayName: "店铺名称" },
            { field: "name", displayName: "法人名称" },
            { field: "money", displayName: "应付款金额" },
            { field: "payTime", displayName: "付款时间" },
          ],
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;white-space:nowrap;padding:8px 10px ;text-align:center",
          type: "json",
        });
      });
    },
  },
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
